import Loadable from 'UIComponents/decorators/Loadable';
import { ErrorLoadingAsync } from './LoadingAsyncComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncUIIFrame = Loadable({
  loader: () => import(
  // @ts-expect-error no-type
  /* webpackChunkName: "ui-iframe" */
  'ui-addon-iframeable/host/UIIFrame').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: ({
    retry
  }) => {
    return /*#__PURE__*/_jsx(ErrorLoadingAsync, {
      retry: retry
    });
  }
});
export default AsyncUIIFrame;